import { l10n } from '@ott/l10n';
import { TimeItem } from '../types';

const getTimeItems = (from: number, to: number): TimeItem[] => {
  return Array(to - from + 1)
    .fill(0)
    .map((_, index) => {
      if (index === 0) {
        return {
          id: null,
          name: l10n('hotelsSearchForm.notChosen'),
        };
      }

      const hour = index - 1 + from;
      const hourPadded = hour < 10 ? `0${hour}` : String(hour);

      return {
        id: `${hourPadded}:00`,
        name: `${hourPadded}:00`,
      };
    });
};

export default getTimeItems;
